import { Component, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { ReactiveFormsModule, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FormService } from '../../../shared/form.service';
import { AuthService } from '../auth.service';
import { UserRequest } from '@generativ/much-smarter-models';
import { AlertService } from '../../alert/alert.service';

@Component({
  selector: 'app-sign-in',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatProgressSpinnerModule,
  ],
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.scss'],
})
export class SignInComponent implements OnInit {
  signInForm: FormGroup;
  loading = signal(false);
  error = '';

  constructor(
    public formService: FormService,
    private authService: AuthService,
    private alertService: AlertService,
    private router: Router,
  ) {
    this.signInForm = this.formService.createForm(this.formOptions);
  }

  ngOnInit() {
    if (this.authService.isAuthenticated()) {
      this.router.navigate(['/']);
    }
  }

  submitForm() {
    this.error = '';

    if (this.formService.validateFormAndUpdateErrors(this.signInForm)) {
      const user = new UserRequest.Login();
      this.loading.set(true);
      user.parse(this.signInForm.value);
      this.authService.signIn(user).pipe(
      ).subscribe(
        (email) => {
          this.alertService.success(`Welcome ${email}`);
          let redirectUrl = localStorage.getItem('redirectUrl');
          redirectUrl = redirectUrl ? redirectUrl : '/';
          this.router.navigate([redirectUrl]);
        },
        (err) => {
          this.loading.set(false);
          this.error = this.getErrorMessage(err);
        },
      );
    }
  }

  private getErrorMessage(error: unknown): string {
    if (error instanceof HttpErrorResponse) {
      const auth0Error = error.error;
      if (auth0Error && typeof auth0Error === 'object') {
        return auth0Error.error_description
          || auth0Error.message
          || 'Authentication failed. Please try again.';
      }
    }

    return typeof error === 'string'
      ? error
      : 'Authentication failed. Please try again.';
  }

  private get formOptions(): object {
    return {
      email: [
        null,
        Validators.compose([Validators.required, Validators.email]),
      ],
      password: [
        null,
        Validators.compose([Validators.required]),
      ],
    };
  }
}
